<template>
    <div class="flex flex-col items-center mt-5">

        <div class="accordion w-[960px] mt-5">
            <h3 class="text-left mb-5 ">Meest gestelde vragen</h3>
            <div v-for="(item, index) in accordionItems" :key="item.id">
                <div class="accordion-item" :class="{ 'open': isOpen(item.id) }">
                    <div :class="['accordion-header', 'text-gamma-blue', isOpen(item.id) ? 'font-semibold' : '']"
                        @click="toggleAccordion(item.id)">
                        <span>{{ item.title }}</span>
                        <svg v-if="!isOpen(item.id)" width="20px" height="20px" viewBox="0 -4.5 24 10" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                            fill="#000000">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <title>arrow_down [#339]</title>
                                <desc>Created with Sketch.</desc>
                                <defs> </defs>
                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="Dribbble-Light-Preview" transform="translate(-180.000000, -6684.000000)"
                                        fill="#003878">
                                        <g id="icons" transform="translate(56.000000, 160.000000)">
                                            <path
                                                d="M144,6525.39 L142.594,6524 L133.987,6532.261 L133.069,6531.38 L133.074,6531.385 L125.427,6524.045 L124,6525.414 C126.113,6527.443 132.014,6533.107 133.987,6535 C135.453,6533.594 134.024,6534.965 144,6525.39"
                                                id="arrow_down-[#339]"> </path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                        <svg v-else width="20px" height="20px" viewBox="0 -4.5 24 10" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                            fill="#000000">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <title>arrow_up [#af4646]</title>
                                <desc>Created with Sketch.</desc>
                                <defs> </defs>
                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="Dribbble-Light-Preview" transform="translate(-140.000000, -6683.000000)"
                                        fill="#003878">
                                        <g id="icons" transform="translate(56.000000, 160.000000)">
                                            <path
                                                d="M84,6532.61035 L85.4053672,6534 L94.0131154,6525.73862 L94.9311945,6526.61986 L94.9261501,6526.61502 L102.573446,6533.95545 L104,6532.58614 C101.8864,6530.55736 95.9854722,6524.89321 94.0131154,6523 C92.5472155,6524.40611 93.9757869,6523.03486 84,6532.61035"
                                                id="arrow_up-[#af4646]"> </path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>

                    </div>
                    <div class="accordion-content font-semibold" v-show="isOpen(item.id)">
                        <span v-html="item.description"></span>
                        <div class="flex p-5 gap-4">
                            <span>Heeft dit je geholpen?</span>
                            <svg viewBox="0 0 25 28" width="30px" height="30px" class="like cursor-pointer" @click="submit(item.id,'like')">
                                <path
                                    d="M4 21c0-0.547-0.453-1-1-1-0.562 0-1 0.453-1 1 0 0.562 0.438 1 1 1 0.547 0 1-0.438 1-1zM6.5 13v10c0 0.547-0.453 1-1 1h-4.5c-0.547 0-1-0.453-1-1v-10c0-0.547 0.453-1 1-1h4.5c0.547 0 1 0.453 1 1zM25 13c0 0.828-0.328 1.719-0.859 2.328 0.172 0.5 0.234 0.969 0.234 1.188 0.031 0.781-0.203 1.516-0.672 2.141 0.172 0.578 0.172 1.203 0 1.828-0.156 0.578-0.453 1.094-0.844 1.469 0.094 1.172-0.172 2.125-0.766 2.828-0.672 0.797-1.703 1.203-3.078 1.219h-2.016c-2.234 0-4.344-0.734-6.031-1.313-0.984-0.344-1.922-0.672-2.469-0.688-0.531-0.016-1-0.453-1-1v-10.016c0-0.516 0.438-0.953 0.953-1 0.578-0.047 2.078-1.906 2.766-2.812 0.562-0.719 1.094-1.391 1.578-1.875 0.609-0.609 0.781-1.547 0.969-2.453 0.172-0.922 0.359-1.891 1.031-2.547 0.187-0.187 0.438-0.297 0.703-0.297 3.5 0 3.5 2.797 3.5 4 0 1.281-0.453 2.188-0.875 3-0.172 0.344-0.328 0.5-0.453 1h4.328c1.625 0 3 1.375 3 3z"
                                    :fill="currentColor"></path>
                            </svg>
                            <svg viewBox="0 0 27 30" class="dislike cursor-pointer" width="30px" height="30px " @click="submit(item.id,'dislike')">
                                <path
                                    d="M4 9c0 0.547-0.453 1-1 1-0.562 0-1-0.453-1-1 0-0.562 0.438-1 1-1 0.547 0 1 0.438 1 1zM6.5 17v-10c0-0.547-0.453-1-1-1h-4.5c-0.547 0-1 0.453-1 1v10c0 0.547 0.453 1 1 1h4.5c0.547 0 1-0.453 1-1zM24.141 14.672c0.531 0.594 0.859 1.5 0.859 2.328-0.016 1.625-1.375 3-3 3h-4.328c0.125 0.5 0.281 0.656 0.453 1 0.406 0.812 0.875 1.719 0.875 3 0 1.203 0 4-3.5 4-0.266 0-0.516-0.109-0.703-0.297-0.672-0.656-0.859-1.625-1.031-2.547-0.187-0.906-0.359-1.844-0.969-2.453-0.484-0.484-1.016-1.156-1.578-1.875-0.688-0.906-2.188-2.766-2.766-2.812-0.516-0.047-0.953-0.484-0.953-1v-10.016c0-0.547 0.469-0.984 1-1 0.547-0.016 1.484-0.344 2.469-0.688 1.687-0.578 3.797-1.313 6.031-1.313h2.016c1.375 0.016 2.406 0.422 3.078 1.219 0.594 0.703 0.859 1.656 0.766 2.828 0.391 0.375 0.688 0.891 0.844 1.469 0.172 0.625 0.172 1.25 0 1.828 0.469 0.625 0.703 1.359 0.672 2.141 0 0.219-0.063 0.688-0.234 1.188z"
                                    :fill="currentColor"></path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    name: 'FAQ',
    components: {

    },
    data() {
        return {
            currentColor: '#003878',
            openIndex: null,
            accordionItems: [
                // { title: 'Waar zijn de opslaglocaties?', description: 'Wij werken in heel Nederland, dus ook bij jou in de buurt. Wij zijn graag de gemakkelijkste keuze, wij komen de spullen bij jou thuis ophalen, slaan ze op en bezorgen ze weer bij je thuis als je ze nodig hebt. Jouw spullen worden opgeslagen in een van onze warehouses centraal in het land.' },
                // { title: 'Hoe zijn mijn spullen beveiligd?', description: 'Het grootste risico komt bij veel opslaglocaties van mede huurders. Daarom heeft bij Inbox alleen geaccrediteerd personeel toegang tot jouw spullen. Desondanks voldoen we ook aan de hoogste eisen die verzekeraars aan opslagbedrijven stellen. Onze gebouwen hebben inbraak-, camera-, toegangsbeveiliging en we houden de temperatuur voor je in de gaten.' },
                // { title: 'Hoe zit het met meer of minder kosten?', description: 'Extra kosten, zoals laadtijd of opslagupgrade, worden achteraf gefactureerd op basis van de hetgeen feitelijk is gebruikt. Dus heb je meer opslagruimte in gebruik dan geboekt of duurde het inladen net even langer dan ontvang je hiervoor een extra factuur.' },
                // { title: 'Zijn mijn spullen verzekerd?', description: 'Bij Inbox ben je standaard gedekt met een basis verzekering voor de werkzaamheden die Inbox voor je uitvoert. Dus als we hebben afgesproken dat jij de spullen inpakt en verpakt maar er ontstaat schade, dan zijn wij hiervoor niet aansprakelijk. <br> Ondanks het feit dat we iedere dag bezig zijn om fouten te minimaliseren en te voorkomen, kan er altijd iets verkeerd gaan. In dat geval zijn we ruim verzekerd tijdens het ophalen, vervoer en terugbrengen van je spullen. Deze dekking is altijd secundair op jouw bestaande inboedelverzekering.' },
                // { title: 'Hoe bereid ik mijn afspraak zo goed mogelijk voor?', description: 'Een goede voorbereiding is natuurlijk het halve werk. Na het boeken zullen wij je met zoveel mogelijk tips helpen. Daarnaast is het belangrijk om je spullen goed in te pakken en te verpakken. Gebruik hiervoor de <a href="https://www.gamma.nl/assortiment/l/meubelen-accessoires/opbergen/verhuisdozen-inpakbenodigdheden" title="verhuisdozen en inpakbenodigheden">verhuisdozen en inpakbenodigheden</a>' },
                // { title: 'Kan ik tussentijds bij mijn spullen?', description: 'Wil je zelf bij je spullen of heb je ineens iets nodig? Dan kunnen wij deze voor minimaal €35 bij je komen terugbrengen. Uiteraard ben je ook welkom bij onze warehouse, centraal in de Randstad. Dat is natuurlijk gratis. Laat het wel even weten, dan zetten we je spullen en de koffie voor je klaar!' },
                // { title: 'Waarom de opslagservice van GAMMA?', description: 'Het opslaan van je spullen wordt vaak onderschat. Voordat het goed kan worden opgeslagen moet je je spullen verpakken, auto regelen, vervoeren, hulp inroepen, je opslagruimte indelen en bij het terugbrengen moet dat allemaal nog een keer. Wij nemen je dit uit handen. <br> Daarnaast zorgen we ervoor dat onze tarieven toch concurrerend zijn met de reguliere tarieven van self storage aanbieders. Dus meer service, voor een concurrerende prijs.' },
                // Add more items as needed
            ]
        }
    },
    mounted(){
        this.getFAQs()
    },
    methods: {
        toggleAccordion(index) {
            if (this.isOpen(index)) {
                this.openIndex = null;
            } else {
                this.openIndex = index;
            }
        },
        isOpen(index) {
            return this.openIndex === index;
        },
        async getFAQs(){
            await axios.get(`https://api.inboxstorage.eu/api/gamma/faqs`).then((response)=>{     
                    console.log(response.data)         
                    this.accordionItems = response.data    
                    }).catch(error => {
                    
                    console.log(error)
                    });
        },
        async submit(index,action){
            let data = {'id': index, 'action':action}
            await axios.post(`https://api.inboxstorage.eu/api/gamma/faqs/servay`,data).then((response)=>{     
                    console.log(response.data)         
                    
                    }).catch(error => {
                    
                    console.log(error)
                    });
        }
    }
}

</script>
<style scoped>
.like,
.dislike {
    width: 30px;
    height: 30px;
    transition: transform 0.3s, fill 0.3s;
    /* Add smooth transition for scaling and color change */
}

/* Define the hover effect */
.like:hover path {
    transform: scale(1.1);
    /* Scale up by 10% on hover */
    fill: #90D384;
    /* Change color to green on hover */
}
.cursor-pointer{
    cursor:pointer
}
.dislike:hover path {
    transform: scale(1.1);
    /* Scale up by 10% on hover */
    fill: #E55026;
    /* Change color to green on hover */
}

.accordion {
    .accordion-item {
        border-bottom: 1px solid #e2e8f0;

        &:last-child {
            border-bottom: none;
        }
    }

    .accordion-header {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1rem 0rem;
        border-top: 1px solid #f0f2f6;

    }

    .accordion-content {
        /* padding: 1rem; */

        border-bottom: 1px solid #e2e8f0;
    }

    .accordion-arrow {
        width: 1.5rem;
        height: 1.5rem;
        fill: currentColor;
        transition: transform 0.3s ease;
        transform: rotate(0deg);
    }

    .font-semibold {
        font-weight: 600;
    }
}
@media screen and (max-width:960px) {
    .w-\[960px\]{
        width:auto;
    }
}
</style>